import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-483887be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "zones-grid-block" }
const _hoisted_2 = { class: "zones-grid-block__header" }
const _hoisted_3 = {
  key: 0,
  class: "header__icon"
}
const _hoisted_4 = { class: "header__title" }
const _hoisted_5 = {
  key: 0,
  class: "zones-grid-block__container"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<table class=\"zones-grid-block__table\" data-v-483887be><thead data-v-483887be><tr data-v-483887be><th data-v-483887be>Мин. вес</th><th data-v-483887be>Фикс.</th><th data-v-483887be>Доп. 1 кг</th></tr></thead><tbody data-v-483887be><tr data-v-483887be><td data-v-483887be>10 кг</td><td data-v-483887be>0 ₸</td><td data-v-483887be>0 ₸</td></tr><tr data-v-483887be><td data-v-483887be>10 кг</td><td data-v-483887be>0 ₸</td><td data-v-483887be>0 ₸</td></tr><tr data-v-483887be><td data-v-483887be>10 кг</td><td data-v-483887be>0 ₸</td><td data-v-483887be>0 ₸</td></tr><tr data-v-483887be><td data-v-483887be>10 кг</td><td data-v-483887be>0 ₸</td><td data-v-483887be>0 ₸</td></tr></tbody></table><div class=\"zones-grid-block__disabled\" data-v-483887be><div class=\"disabled__message\" data-v-483887be>Авиаперевозка недоступна для внутригородской доставки</div></div>", 2)
const _hoisted_8 = [
  _hoisted_6
]
const _hoisted_9 = {
  key: 1,
  class: "zones-grid-block__container"
}
const _hoisted_10 = { class: "zones-grid-block__table" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Мин. вес"),
    /*#__PURE__*/_createElementVNode("th", null, "Фикс."),
    /*#__PURE__*/_createElementVNode("th", null, "Доп. 1 кг")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$slots['icon'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
      (_ctx.zoneId === 6 || _ctx.zoneId === 7)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["header__badge", { 'badge--auto': _ctx.isAuto, 'badge--avia': _ctx.isAvia }])
          }, " Доплата ", 2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isAvia && _ctx.zoneId === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tariffs, (tariff, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `tariff-${i}`
                }, [
                  _createElementVNode("td", null, _toDisplayString(tariff.weight) + " кг", 1),
                  _createElementVNode("td", null, _toDisplayString(tariff.fixedPrice) + " ₸", 1),
                  _createElementVNode("td", null, _toDisplayString(tariff.dopPrice) + " ₸", 1)
                ]))
              }), 128))
            ])
          ])
        ]))
  ]))
}